import TicketStatusDialogThreat from './TicketStatusDialogThreat';

export * from './TicketStatusDialogThreat.types';
export default TicketStatusDialogThreat;
